import React, { useState, useRef, useEffect } from 'react';
import { exportTableToCSV, exportTableToExcel } from '../utils/exportData';

const ExportDropdown = ({
  tableData,
  columns,
  filenamePrefix = 'export',
  rowLabels = {},
  configsLine = [],
  configsUnit = {},
  language = 'french',
  showUnitRow = true,
  showTotal = true,
  activeUnitLabel = '',
  showUnitInHeaderLabels = true
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const buildExport = () => {
    const langKeyMap = { french: 'label_fr', english: 'label_en', portugais: 'label_pr', swahili: 'label_sw' };
    const langKey = langKeyMap[language] || 'label_fr';

    // colonnes avec labels localisés et unité
    const columnsExport = columns.map(c => {
      const colId = c.id ?? c.fk_data_id;
      const title = c[langKey] ?? c.label_fr ?? c.label_en ?? colId;
      const unitLabel = c[`unitlabel${langKey.replace('label_','')}`] ?? c.unitlabel_fr ?? c.unitlabel_en ?? c.unitlabel_pr ?? c.unitlabel_sw ?? '';
      const label = showUnitInHeaderLabels && unitLabel ? `${title} (${unitLabel})` : title;
      return { id: colId, label, unitLabel };
    });

    const firstHeaderLabel = activeUnitLabel || (configsUnit ? (configsUnit[langKey] ?? configsUnit.label_fr ?? configsUnit.label_en ?? '') : '');

    // lignes exportées
    const rowsArray = configsLine.map(item => {
      const rowId = item.fk_data_id;
      const row = tableData?.[rowId] || {};
      const label = item[langKey] ?? item.label_fr ?? item.label_en ?? rowId;
      let total = 0;
      const cells = columns.map(c => {
        const val = Number(row[c.fk_data_id ?? c.id]);
        const str = isFinite(val) ? val.toFixed(2) : '';
        if (str !== '') total += Number(str);
        return str;
      });
      return [label, ...cells, showTotal ? (total !== 0 ? total.toFixed(2) : '') : undefined].filter(v => v !== undefined);
    });

    // colonne TOTAL
    const totalLabelMap = { french: 'TOTAL', english: 'TOTAL', portugais: 'TOTAL', swahili: 'JUMLA' };
    const totalLabel = totalLabelMap[language] ?? 'TOTAL';
    const columnsExportWithTotal = showTotal ? [...columnsExport, { id: 'TOTAL', label: totalLabel }] : columnsExport;

    return { rowsArray, columnsExport: columnsExportWithTotal, firstHeaderLabel };
  };

  const handleCSV = () => {
    setOpen(false);
    const { rowsArray, columnsExport, firstHeaderLabel } = buildExport();
    exportTableToCSV(rowsArray, columnsExport, `${filenamePrefix}.csv`, firstHeaderLabel);
  };

  const handleExcel = () => {
    setOpen(false);
    const { rowsArray, columnsExport, firstHeaderLabel } = buildExport();
    exportTableToExcel(rowsArray, columnsExport, `${filenamePrefix}.xlsx`, firstHeaderLabel);
  };

  useEffect(() => {
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  return (
    <div ref={ref} style={{ display: 'inline-block', position: 'relative', marginLeft: 12 }}>
      <button type="button" className="btn btn-outline-primary" onClick={() => setOpen(v => !v)}>
        Export
      </button>
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1000, minWidth: 140 }} className="card shadow-sm">
          <div className="list-group list-group-flush">
            <button className="list-group-item list-group-item-action" onClick={handleCSV}>Export CSV</button>
            <button className="list-group-item list-group-item-action" onClick={handleExcel}>Export Excel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;